if (!customElements.get("video-reels")) {
  customElements.define(
    "video-reels",
    class VideoReels extends HTMLElement {
      constructor() {
        super();
        this.activeClass = "active";
        this.swiper = this.querySelector(".wt-slider__container");
      }

      connectedCallback() {
        this.init();
      }

      updateAllVideosSound(swiper) {
        const soundOn = swiper.el.dataset.sound === "on";
        swiper.slides.forEach((slide) => {
          const video = slide.querySelector("video");
          if (video) {
            video.muted = !soundOn;
          }
        });
      }

      observeSection() {
        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        };

        const sectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = this.querySelector(".swiper-slide-active video");

              if (video && !entry.isIntersecting) {
                video.pause();
              }
            });
          },
          observerOptions,
        );

        sectionObserver.observe(this);
      }

      handleSoundToggle(swiper) {
        swiper.slides.forEach((slide) => {
          const button = slide.querySelector(".wt-video__sound-toggle");
          const video = slide.querySelector("video");

          if (!button || !video) return;

          button.addEventListener("click", () => {
            if (video.muted) {
              video.muted = false;
              swiper.el.dataset.sound = "on";
            } else {
              video.muted = true;
              swiper.el.dataset.sound = "off";
            }
            this.updateAllVideosSound(swiper);
          });
        });
      }

      pauseAllVideos() {
        const videos = this.querySelectorAll("video");
        videos.forEach((video) => {
          video.pause();
        });
      }

      playVideoInActiveSlide(swiper) {
        const sound = swiper.el.dataset.sound;
        const activeSlideVideo = this.findActiveSlide(swiper)?.querySelector("video");

        if (activeSlideVideo) {
          activeSlideVideo.play().catch(() => {});
          activeSlideVideo.muted = sound !== "on";
        }
      }

      findActiveSlide(swiper) {
        return swiper.slides[swiper.activeIndex];
      }

      syncVideoContainerWidths(swiper) {
        if (!swiper?.slides) return;
        const shouldApplyInlineWidth = window.matchMedia("(min-width: 900px)").matches;

        swiper.slides.forEach((slide) => {
          const videoContainer = slide.querySelector(".video-container");
          if (!videoContainer) return;

          if (shouldApplyInlineWidth) {
            const slideWidth = slide.style.width;
            if (slideWidth) {
              videoContainer.style.width = slideWidth;
            } else {
              videoContainer.style.width = "100%";
            }
            videoContainer.style.maxWidth = "100%";
          } else {
            videoContainer.style.removeProperty("width");
            videoContainer.style.removeProperty("max-width");
          }
        });
      }

      toggleActiveClass(swiper) {
        const activeSlide = this.findActiveSlide(swiper);
        swiper.slides.forEach((slide) => {
          slide.classList.remove(this.activeClass);

          if (activeSlide === slide) {
            slide.classList.add(this.activeClass);
          }
        });
      }

      handleSlideChange(swiper) {
        this.syncVideoContainerWidths(swiper);
        this.pauseAllVideos();
        this.toggleActiveClass(swiper);
      }

      addVideoEventHandlers(swiper) {
        swiper.on("slideChange", (swp) => this.handleSlideChange(swp));
        swiper.on("resize", (swp) => this.syncVideoContainerWidths(swp));
        swiper.on("update", (swp) => this.syncVideoContainerWidths(swp));
      }

      checkSwiperInitialization() {
        const swiperContainer = this.swiper;
        const mySwiperInstance = swiperContainer?.swiper;

        if (
          swiperContainer &&
          swiperContainer.classList.contains("swiper-initialized") &&
          mySwiperInstance
        ) {
          this.addVideoEventHandlers(mySwiperInstance);
          this.syncVideoContainerWidths(mySwiperInstance);
          this.toggleActiveClass(mySwiperInstance);
          this.pauseAllVideos();
          this.handleSoundToggle(mySwiperInstance);
          this.observeSection();
          clearInterval(this.checkInterval);
        }
      }

      init() {
        this.checkInterval = setInterval(
          this.checkSwiperInitialization.bind(this),
          500,
        );
      }

    },
  );
}